<template>
  <div class="kanban-container" ref="kanban">
    <div style="padding-top: 10px;padding-bottom: 10px;">

      <img class="oee-bg-img-top" :src="require('../../assets/oee-4.png')" />
      <div class="production-kanban-header">【{{ companyName }}】生产实时看板</div>
    </div>

    <div class="prod-kanban-header-two">
      <div style="background-color: blue;">设备数 <span>{{ totalEquip }}</span> 台</div>
      <div style="background-color: green;">生产中 <span>{{ equipInProd }}</span> 台</div>
      <div style="background-color: orange;">待机 <span>{{ equipInWait }}</span> 台</div>

      <div style="background-color: red;">暂停 <span>{{ equipInPause }}</span> 台</div>
      <div style="background-color: black;">检修 <span>{{ equipInMend }}</span> 台</div>

      <div style="background-color: skyblue;">排队 <span>{{ queueCount }}</span></div>
    </div>

    <div style="overflow: auto; height: 60%">
      <table class="kanban-table" style="width: 2000px">
        <tr>
          <td style="width: 10px; max-width: 10px" v-if="cEquipCode == 1">设备编号</td>
          <td style="width: 40px; max-width: 40px" v-if="cOrderCode == 1">订单编号</td>
          <td style="width: 10px; max-width: 10px" v-if="cSalesman == 1">业务代号</td>

          <td style="width: 30px; max-width: 30px" v-if="cCustomer == 1">客户</td>

          <td style="width: 70px; max-width: 70px" v-if="cProductName == 1">产品名称</td>
          <td style="width: 40px; max-width: 45px" v-if="cOrderRemark == 1">备注</td>

          <td style="width: 25px; max-width: 25px" v-if="cOrderCount == 1">订单数</td>
          <td style="width: 25px; max-width: 25px" v-if="cCompleteCount == 1">完成数</td>

          <td style="width: 30px; max-width: 30px" v-if="cCompleteRate == 1">完成率</td>
          <td style="width: 10px; max-width: 10px" v-if="cInspectionStatus == 1">首检</td>

          <td style="width: 20px;max-width: 20px;" v-if="cTakeTime == 1">标准周期</td>
          <td style="width: 20px;max-width: 20px;" v-if="cActualTime == 1">实际周期</td>

          <td style="width: 40px; max-width: 40px" v-if="cStartTime == 1">上机时间</td>
          <td style="width: 10px; max-width: 10px" v-if="cEquipStatus == 1">设备状态</td>
          <td style="width: 15px; max-width: 15px" v-if="cEquipStatus == 1">状态时长</td>

          <td style="width: 70px; max-width: 70px" v-if="cQueueOne == 1">排队1</td>
          <td style="width: 55px; max-width: 55px" v-if="cQueueTwo == 1">排队2</td>
          <td style="width: 55px; max-width: 55px" v-if="cQueueThree == 1">排队3</td>

          <td style="width: 20px; max-width: 20px" v-if="cRemainder == 1">剩余时间</td>
        </tr>

        <tr v-for="(item, index) in productionKanbanList" :key="index">
          <td v-if="cEquipCode == 1">{{ item.equipmentCode }}</td>
          <td v-if="cOrderCode == 1">{{ item.orderCode }}</td>
          <td v-if="cSalesman == 1">{{ item.salesman }}</td>
          <td v-if="cCustomer == 1">{{ item.customer }}</td>
          <td v-if="cProductName == 1" style="text-align: left;">{{ item.productName }}</td>
          <td v-if="cOrderRemark == 1">{{ item.remark }}</td>

          <td v-if="cOrderCount == 1">{{ item.orderCount }}</td>

          <td v-if="cCompleteCount == 1">{{ item.completeCount }}</td>

          <td v-if="cCompleteRate == 1" style="padding: 0;">
            <el-progress :text-inside="true" :stroke-width="38"
              :percentage="toFloat3(item.completeCount / item.orderCount)" status="success"></el-progress>
          </td>

          <td v-if="cInspectionStatus == 1">{{ item.inspectionStatus }}</td>

          <td v-if="cTakeTime == 1">{{ item.takeTime == 0 ? '' : item.takeTime }}</td>
          <td v-if="cActualTime == 1"
            :class="(item.actualTime >= 300 || item.actualTime == null) && item.statusStr == '生产' ? 'kanban-td-y' : item.actualTime > item.takeTime + 5 ? 'kanban-td-r' : 'kanban-td-g'">
            {{ item.actualTime == 0 ? '' : item.actualTime }}</td>

          <td v-if="cStartTime == 1">{{ item.startTime }}</td>

          <td v-if="cEquipStatus == 1"
            :class="item.statusStr == '待机' ? 'kanban-td-o' : item.statusStr == '生产' ? 'kanban-td-g' : 'kanban-td-r'">
            {{ item.statusStr }}</td>
          <td v-if="cEquipStatus == 1" style="color: orange;">{{ item.statusDuration }}</td>

          <td v-if="cQueueOne == 1" style="text-align: left;">{{ item.productOne }}</td>
          <td v-if="cQueueTwo == 1" style="text-align: left;">{{ item.productTwo }}</td>
          <td v-if="cQueueThree == 1" style="text-align: left;">{{ item.productThree }}</td>

          <td v-if="cRemainder == 1">{{ item.remainder == null ? "" : item.remainder + "H" }}</td>
        </tr>
      </table>

      <div style="height: 10px"></div>
    </div>

    <div style="height: 10px"></div>

    <!-- 分页 -->
    <div>
      <el-pagination background :page-size="pageNum" :page-count="pageCount" layout="total, sizes,prev, pager, next"
        :total="total" @current-change="pageClick" :page-sizes="[8, 10, 15, 20]" @size-change="handleSizeChange">
      </el-pagination>
    </div>

    <div style="height: 10px"></div>

    <div style="position: absolute; right: 60px; bottom: 5px">
      <i class="el-icon-download" @click="exportExcel" style="color: orange"></i>
    </div>

    <div style="position: absolute; right: 30px; bottom: 5px">
      <i class="el-icon-full-screen" @click="fullScreen" style="color: orange"></i>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      token: this.getToken(),
      companyId: this.getCompanyId(),
      userId: this.getUserId(),
      companyName: "中国制造",

      totalEquip: 0,
      equipInWait: 0,
      equipInProd: 0,
      equipInMend: 0,
      equipInPause: 0,
      queueCount: 0,

      productionKanbanList: [],

      cEquipCode: 1,
      cOrderCode: 1,
      cSalesman: 1,
      cCustomer: 1,
      cProductName: 1,
      cOrderRemark: 1,

      cOrderCount: 1,
      cCompleteCount: 1,
      cCompleteRate: 1,
      cInspectionStatus: 1,
      cTakeTime: 1,
      cActualTime: 1,

      cStartTime: 1,
      cEquipStatus: 1,
      cQueueOne: 1,

      cQueueTwo: 1,
      cQueueThree: 1,
      cRemainder: 1,

      index: 0,

      pageIndex: 0,
      pageNum: 8,
      total: 0,
      pageCount: 0,

      timer: ''
    }
  },
  methods: {
    exportExcel() {

      this.$axios({
        method: "post",
        url: "/shiro/product/kanban/excel",
        data: {
          companyId: this.companyId
        },
        headers: {
          token: this.token
        },
        responseType: 'arraybuffer'
      }).then(result => {

        const data = result.data

        let objectUrl = result.config.url
        const blob = new Blob([data], {
          type: 'application/vnd.ms-excel;charset=utf-8'
        })

        objectUrl = URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.href = objectUrl

        a.download = this.$moment(new Date()).format("YYYY-MM-DD HH:mm") + "生产看板导出.xlsx"
        a.click()
        a.remove()
        URL.revokeObjectURL(objectUrl)
      })
    },
    getAll() {
      const formData = new FormData()

      formData.append("companyId", this.companyId)

      formData.append("pageIndex", this.pageIndex)
      formData.append("pageNum", this.pageNum)

      this.$axios({

        method: "post",
        url: "/shiro/product/kanban/getAll",
        data: formData,
        headers: {
          token: this.token,
        },
      }).then((result) => {

        const data = result.data

        if (data.status === 202) {
          this.$notify({
            title: "重要提示",
            message: data.msg,
            duration: 0,
          })
          return
        }

        if (data.status === 400 || data.status != 200) {

          clearInterval(this.timer)

          this.$router.push({ path: "/Login" })
        }

        this.productionKanbanList = data.data

        this.total = this.productionKanbanList[0].total

        this.totalEquip = this.productionKanbanList[0].totalEquip
        this.equipInWait = this.productionKanbanList[0].equipInWait
        this.equipInProd = this.productionKanbanList[0].equipInProd
        this.equipInMend = this.productionKanbanList[0].equipInMend
        this.equipInPause = this.productionKanbanList[0].equipInPause
        this.queueCount = this.productionKanbanList[0].queueCount

        for (let i in this.productionKanbanList) {

          if (this.productionKanbanList[i].startTime) {
            this.productionKanbanList[i].startTime = this.$moment(
              this.productionKanbanList[i].startTime
            ).format("YYYY-MM-DD HH:mm")

            if (this.productionKanbanList[i].startTime == "1970-01-01 08:00") {
              this.productionKanbanList[i].startTime = ""
            }
          }

          if (this.productionKanbanList[i].inspectionStatus == 1) {
            this.productionKanbanList[i].inspectionStatus = "✅"
          } else {
            this.productionKanbanList[i].inspectionStatus = ""
          }
        }

      })
    },
    toFloat3(val) {

      if (isNaN(val)) {
        val = 0
      }

      return parseFloat((val.toFixed(3) * 100).toFixed(10))
    },
    fullScreen() {
      // console.log('fullScreen')
      let element = this.$refs.kanban
      // console.log(element)

      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen

    },
    pageClick(currentPage) {
      this.purchaseKanbanList = []

      this.pageIndex = (currentPage - 1) * this.pageNum

      this.getAll()
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pageNum = val

      this.getAll()
    },
    getShowColumn() {

      this.$axios({
        method: "post",
        url: "/shiro/product/kanban/getSet",
        data: {
          companyId: this.companyId,
          userId: this.userId
        },
        headers: {
          token: this.token,
        },
      }).then((result) => {

        const data = result.data

        if (data.data != null) {

          this.cEquipCode = data.data.equipCodeC

          this.cOrderCode = data.data.orderCodeC
          this.cSalesman = data.data.salesmanC


          this.cCustomer = data.data.customerC
          this.cProductName = data.data.productNameC
          this.cOrderRemark = data.data.orderRemarkC

          this.cOrderCount = data.data.orderCountC
          this.cCompleteCount = data.data.completeCountC
          this.cCompleteRate = data.data.completeRateC
          this.cInspectionStatus = data.data.inspectionStatusC
          this.cTakeTime = data.data.takeTimeC
          this.cActualTime = data.data.actualTimeC

          this.cStartTime = data.data.startTimeC
          this.cEquipStatus = data.data.equipStatusC
          this.cQueueOne = data.data.queueOneC

          this.cQueueTwo = data.data.queueTwoC
          this.cQueueThree = data.data.queueThreeC
          this.cRemainder = data.data.remainderC
        }

      })

    }
  },
  mounted() {
    this.setDefaultPath('/productionKanban')

    this.getShowColumn()

    this.getAll()

    this.$axios({
      method: "post",
      url: "/shiro/company/get",
      data: {
        id: this.companyId,
      },
      headers: {
        token: this.token,
      },
    }).then((result) => {

      this.companyName = result.data.data.companyName
    })

    this.timer = setInterval(() => {
      
      this.getAll()
    }, 20000)

  },
  updated() {
    var ele = document.getElementsByClassName("el-progress-bar__inner")

    // console.log('upp')
    // console.log(ele)
    for (let i in ele) {
      var str = ele[i].attributes.style.value
      // console.log(str)
      var s = str.indexOf(":")
      var e = str.indexOf("%")

      var w = str.substring(s + 1, e)
      // console.log('---')
      // console.log(s)
      if (parseInt(w) > 100) {
        // console.log('>100')
        ele[i].attributes.style.value = "width:100%"
      }
    }

  }
}
</script>

<style>
.kanban-container {
  width: 100%;
  height: 735px;
  background-color: #06207d;
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  position: relative;
}

.production-kanban-header {
  position: absolute;
  color: white;
  top: 2%;
  left: 30%;
  font-size: 23px;
  font-weight: bold;
  width: 38%;
}

.oee-bg-img-top {
  width: 90%;
  height: 130px;
}

.prod-kanban-header-two {
  display: flex;
  color: white;
}

.prod-kanban-header-two div {
  margin: 10px 10px;
  padding: 15px 20px;
  width: 12%;
}

.prod-kanban-header-two div span {
  font-size: 25px;
}

.kanban-table {
  width: 556px;
  table-layout: fixed;
  border: 1px solid #e5e7eb;
  font-size: 15px;
  font-weight: bold;
  color: white;
  border-collapse: collapse;
}

.kanban-tr-odd {
  font-size: 11px;
  color: black;
  background-color: white;
}

.kanban-tr {
  font-size: 11px;
  color: black;
  background-color: greenyellow;
}

.kanban-table td {
  border: 1px solid blue;
  padding: 7px 0;
}

.kanban-tr-odd td,
.kanban-tr td {
  border: 1px solid black;
}

.kanban-td-o {
  background-color: orange;
}

.kanban-td-g {
  background-color: green;
}

.kanban-td-r {
  background-color: red;
}


div::-webkit-scrollbar {
  background: #6f5499;
  border-radius: 10px;
  width: 10px;
  height: 10px;
}

div::-webkit-scrollbar-thumb {
  background: orange;
  border-radius: 10px;
}

.el-pagination__total {
  color: pink;
}
</style>